// Token storage strategy: the access token (and optional refresh token) are kept in
// localStorage so the session survives a page refresh without an extra round trip on
// every load. Trade-off: localStorage is readable by any script on the page, so it is
// more exposed to XSS than an httpOnly cookie or in-memory-only storage. For an
// internal farm-management tool accessed over a controlled network this is an
// acceptable trade-off in exchange for simplicity (no silent-refresh dance, works
// identically for the web app and the future APK's WebView bridge). If this becomes a
// public-internet-facing product, migrate to httpOnly refresh cookies + short-lived
// in-memory access tokens.

const ACCESS_TOKEN_KEY = 'ilms_access_token';
const REFRESH_TOKEN_KEY = 'ilms_refresh_token';

export const tokenStorage = {
  getAccessToken(): string | null {
    try {
      return localStorage.getItem(ACCESS_TOKEN_KEY);
    } catch {
      return null;
    }
  },
  getRefreshToken(): string | null {
    try {
      return localStorage.getItem(REFRESH_TOKEN_KEY);
    } catch {
      return null;
    }
  },
  setTokens(accessToken: string, refreshToken?: string): void {
    try {
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
      if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    } catch {
      // ignore storage failures (private browsing etc.)
    }
  },
  clear(): void {
    try {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    } catch {
      // ignore
    }
  },
};
